import { render } from "./DiscussionListUsersModal.vue?vue&type=template&id=5efbfb12&scoped=true"
import script from "./DiscussionListUsersModal.vue?vue&type=script&lang=js"
export * from "./DiscussionListUsersModal.vue?vue&type=script&lang=js"

import "./DiscussionListUsersModal.vue?vue&type=style&index=0&id=5efbfb12&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efbfb12"]])

export default __exports__